import { useEffect, useState } from "react";
import { Button, Card, Flex, Typography } from "antd";
import RequestAccessUnitsTable from "@/components/tables/RequestAccessUnitsTable";
import RequestUnitsModal from "@/components/modals/RequestUnitsModal";
import { getUnitsOptions } from "@/api/units";
import EditIcon from "@/icons/EditIcon";
import InfoCircleTooltip from "@/components/ui/InfoCircleTooltip";

const AccessUnitsCard = ({
  data,
  requestUnits,
  loading,
  isDeleted,
  fetchData,
}) => {
  const [isUnitEditModal, setIsUnitEditModal] = useState(false);

  const [units, setUnits] = useState([]);

  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const { units } = await getUnitsOptions();

        setUnits(units);
      } catch (e) {
        console.log(e);
      }
    };

    fetchUnits();
  }, [requestUnits]);

  const handleAddUnit = () => {
    setIsUnitEditModal(true);
  };

  const onCancel = () => {
    setIsUnitEditModal(false);
  };

  const onSave = () => {
    setIsUnitEditModal(false);
    fetchData();
  };

  return (
    <Card
      id="units-access-table"
      type="small"
      title={
        <Typography.Title level={5} className="no-margin">
          <Flex gap={10} align="center">
            <span>Инициаторы заявок</span>
            <InfoCircleTooltip placement="top" size={20}>
              Рабочие группы, участники которых могут создавать заявки
            </InfoCircleTooltip>
          </Flex>
        </Typography.Title>
      }
      extra={
        !isDeleted && (
          <Button type="primary" icon={<EditIcon />} onClick={handleAddUnit} />
        )
      }
      style={{ boxShadow: "none" }}
    >
      <RequestAccessUnitsTable data={requestUnits} loading={loading} />

      {isUnitEditModal && (
        <RequestUnitsModal
          data={data}
          requestUnits={requestUnits?.map((u) => ({
            ...u,
            uuid: u.unit_uuid,
            link_uuid: u.uuid,
          }))}
          units={units}
          visible={isUnitEditModal}
          onCancel={onCancel}
          onSave={onSave}
        />
      )}
    </Card>
  );
};

export default AccessUnitsCard;
